
/**
 * Import the necessary dependencies for rendering a React component.
 * @module React
 * @module EventListComponent
 */

import React from "react";
import EventListComponent from "./eventListComponent";

const EventListContainer = (props) => {  
  /**
   * Represents a page title.
   * @type {{Array<{title: string}>}}
   */
 
  const pageTitle = [{title: 'Events'}]

  return (
    <EventListComponent
      pageTitle={pageTitle}
    />
  );
};

export default EventListContainer;
